import React from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import sortBy from 'lodash/sortBy'

import Icon from 'discada/dist/Icon'
import Tag from 'discada/dist/Tag'

import {
  hasDataOneData,
  getWarrantyInfo,
  getIsUsedCar,
  getDataOneWarranties,
} from 'selectors/inventorySelectors'
import {
  getWarrantyCoverageBreakdown,
  doesWarrantyRunOut,
  doesAnyWarrantyRunOut,
} from 'selectors/quoteSelectors'

import { numShort } from 'utils'

import './Warranty.scss'

export function DataOneWarranties(props) {
  if (isEmpty(props.dataOneWarranties) || props.isUsed) return null

  let { checkWarrantyCoverage, anyWarrantyRunsOut } = props,
    getTag = w => {
      let runsOut = checkWarrantyCoverage(w),
        color = runsOut ? 'warning' : 'success',
        icon = runsOut ? 'exclamation-triangle' : 'check',
        label = runsOut ? 'Coverage Runs Out' : 'Full Term Coverage'

      return (
        <Tag compound size="small">
          <Tag color={color}>
            <Icon icon={icon} fixedWidth />
          </Tag>
          <Tag color="white" className="coverage-label">
            {label}
          </Tag>
        </Tag>
      )
    },
    getDeets = (w = {}) => {
      let { months, miles } = w

      return [
        parseInt(months, 10) > 0 ? `${months / 12} years` : null,
        parseInt(miles, 10) > 0 ? `${numShort(miles)} miles` : null,
      ]
        .filter(x => x)
        .join(' or ')
    }

  return (
    <div
      className="vehicle-warranties data-one-warranties vrp-section"
      id="vrp-warranties"
    >
      {anyWarrantyRunsOut && (
        <article className="message is-warning">
          <div className="message-body">
            One or more of the included warranties for this vehicle will expire
            before you have it paid off. Consider adding an extended warranty
          </div>
        </article>
      )}

      <ul>
        {sortBy(props.dataOneWarranties, w =>
          parseInt(w.months, 10) > 0 ? w.months : 1000,
        ).map((w, i) => (
          <li key={i}>
            <strong>
              {getTag(w)}
              {w.name}
            </strong>
            <span className="warranty-deets">{getDeets(w)}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

// TOOD REMOVE THIS EVENTUALLY
export function ChromeWarranties(props) {
  if (isEmpty(props.warrantyInfo) || props.isUsed) return null

  let wi = props.warrantyInfo,
    { coverages, noCoverges, term } = props

  return (
    <div
      className="vehicle-warranties chrome-warranties vrp-section"
      id="vrp-warranties"
    >
      {!noCoverges && (
        <div className="coverage-message">
          Your selected payment has a <strong>term of {term / 12} years</strong>
          . Compare that to the included warranty coverage.
        </div>
      )}

      {Object.keys(wi)
        .sort((a, b) => wi[a].years - wi[b].years)
        .map(k => (
          <p key={k}>
            {!noCoverges && (
              <span>
                {coverages[k] ? (
                  <Icon icon="check-circle" />
                ) : (
                  <Icon icon="minus-circle" />
                )}
              </span>
            )}
            <span>{k} Coverage</span>
            <span>
              {wi[k].years} years / {wi[k].miles} miles
            </span>
            {!noCoverges && (
              <span className="coverage-label">
                {coverages[k] ? 'Full Coverage' : 'Coverage Runs Out!'}
              </span>
            )}
          </p>
        ))}
      <div className="disclaimer">Check with us for coverage specifics</div>
    </div>
  )
}

export function Warranties(props) {
  return props.useDataOne ? (
    <DataOneWarranties {...props} />
  ) : (
    <ChromeWarranties {...props} />
  )
}

function mapStateToProps(state, op) {
  let useDataOne = hasDataOneData(state, op.id)

  return {
    ...op,
    useDataOne,
    isUsed: getIsUsedCar(state, op.id),
    dataOneWarranties: getDataOneWarranties(state, op.id),
    warrantyInfo: getWarrantyInfo(state, op.id),
    coverages: getWarrantyCoverageBreakdown(state, op.id, op.quoteId, op.mode),
    anyWarrantyRunsOut: doesAnyWarrantyRunOut(
      state,
      op.id,
      op.quoteId,
      op.mode,
    ),
    checkWarrantyCoverage: w =>
      doesWarrantyRunOut(state, op.id, op.quoteId, op.mode, w),
  }
}

export default connect(mapStateToProps)(Warranties)
